module.exports = __webpack_public_path__ + "img/subs_up.a1a2be11.svg";